export { AWSS3Provider } from './AWSS3Provider';
//# sourceMappingURL=index.js.map